import React, { useContext, useState, useEffect } from 'react'
import { Divider, ListItem } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { getUserProfileErrorMessage } from '@/custom/common/components'

import { NavLink } from 'react-router-dom'
import './Dashboard.css'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { handleRedirectInternal } from '@/custom/common/components'
import AuthContext from '@/product/context/auth/authContext'
import DynamicListing from '@/views/Seller/Dashboard/Listing/dynamicListing'
import AlertContext from '@/product/context/alert/alertContext'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
}))

const SideNav = () => {
    const classes = useStyles()
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { user } = authContext

    const [expanded, setExpanded] = useState('')

    const handleChange = (panel) => {
        if (expanded === panel) {
            setExpanded('')
        } else {
            setExpanded(panel)
        }
    }

    useEffect(() => {
        if (location.pathname.split('/')[1]) {
            setExpanded(location.pathname.split('/')[1])
        }
    }, [location.pathname])
    const [title, setTitle] = useState('Edit Offer')
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
    })

    const toggleFullScreenPopup = (popup, status, id, fieldStatus) => {
        if (popup) {
            setManage({ popup, status, id })
        } else if (status !== '') {
            setManage({ popup, status: 'new', id: 0 })
        }
        if (fieldStatus) {
            setTitle('View Offer')
        } else {
            setTitle('Edit Offer')
        }
    }

    function ProtectedNavLink({ to, children, errorMessage, onClick, ...rest }) {
        const handleClick = (event) => {
            if (!user?.seniority) {
                /**
                 * block navigation if profile not update based on user. seniority field
                 */
                event.preventDefault()
                const ERROR_MESSAGE = getUserProfileErrorMessage(user)
                setAlert(ERROR_MESSAGE, 'error')
                handleRedirectInternal(history, 'account/profile')

                return
            }

            // if (onClick) {
            //     onClick()
            // }
            /**
             *  allowed → let NavLink handle navigation normally
             */
        }

        return (
            <NavLink to={to} activeClassName="active" onClick={handleClick} {...rest}>
                {children}
            </NavLink>
        )
    }

    return (
        <div className="sideNav">
            {/* <div className="userAvatarProfile">
                <span className="userInitials large">
                    {user?.first_name?.charAt(0)}
                    {user?.last_name?.charAt(0)}{' '}
                </span>
                <h4>
                    {'Hello'} {user?.first_name !== 'null' ? user?.first_name : user?.companyname}
                </h4>
            </div> */}
            <ul>
                <ListItem button onClick={() => handleChange('account')} id="sidebar_myaccount">
                    <div
                        className={`d-flex justify-content-between align-items-center w-100 test ${
                            expanded === 'account' && 'activeDropdown'
                        }`}
                    >
                        <span className="d-flex navDrop">
                            <span className="material-icons">person</span>
                            {'My Account'}
                        </span>
                        {expanded === 'account' ? <ExpandLess /> : <ExpandMore />}
                    </div>
                </ListItem>

                <Collapse in={expanded === 'account'} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/account/profile"
                                id="sidebar_profile"
                            >
                                {'Profile'}
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <ProtectedNavLink
                                activeClassName="active"
                                to="/account/change"
                                id="sidebar_changepassword"
                            >
                                {'Change Password'}
                            </ProtectedNavLink>
                        </ListItem>
                        {user?.admin && !user.both_access ? null : (
                            <>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/account/notifications"
                                        id="sidebar_mynotification"
                                    >
                                        {'My Notifications'}
                                    </ProtectedNavLink>
                                </ListItem>
                            </>
                        )}
                        {/* <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/payments/subscription"
                                id="sidebar_changepassword"
                            >
                                {'My Subscription'}
                            </NavLink>
                        </ListItem> */}
                    </List>
                </Collapse>

                {user?.admin ? (
                    <>
                        {user?.both_access ? (
                            <>
                                <ListItem
                                    button
                                    onClick={() => handleChange('auctions')}
                                    id="sidebar_mybids"
                                >
                                    <div
                                        className={`d-flex justify-content-between align-items-center w-100 test ${
                                            expanded === 'auctions' && 'activeDropdown'
                                        }`}
                                    >
                                        <span className="d-flex navDrop">
                                            <span className="material-icons">gavel</span>
                                            {'My Bids'}
                                        </span>
                                        {expanded === 'auctions' ? <ExpandLess /> : <ExpandMore />}
                                    </div>
                                </ListItem>
                                <Collapse in={expanded === 'auctions'} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        <ListItem button>
                                            <ProtectedNavLink to="/auctions/ioi/ioi_request">
                                                {/* <span className="material-icons">storefront</span>{' '} */}
                                                {'Indication of Interest Request'}
                                            </ProtectedNavLink>
                                        </ListItem>
                                        <ListItem button>
                                            <ProtectedNavLink
                                                to="/auctions/all"
                                                id="sidebar_all_bids"
                                            >
                                                {'All'}
                                            </ProtectedNavLink>
                                        </ListItem>

                                        <ListItem button>
                                            <ProtectedNavLink
                                                to="/auctions/winning"
                                                id="sidebar_winning_bids"
                                            >
                                                {'Winning'}
                                            </ProtectedNavLink>
                                        </ListItem>

                                        <ListItem button>
                                            <ProtectedNavLink
                                                to="/auctions/outbid"
                                                id="sidebar_outbid_bids"
                                            >
                                                {'Currently Outbid'}
                                            </ProtectedNavLink>
                                        </ListItem>
                                        <ListItem button>
                                            <ProtectedNavLink
                                                to="/auctions/won"
                                                id="sidebar_won_bids"
                                            >
                                                {'Won'}
                                            </ProtectedNavLink>
                                        </ListItem>
                                    </List>
                                </Collapse>
                                {/* <ListItem button>
                                    <NavLink activeClassName="active" to="/ioi_request">
                                        <span className="material-icons">storefront</span>{' '}
                                        {'Indication of Interest Request'}
                                    </NavLink>
                                </ListItem> */}
                                {/* <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/alloffers"
                                id="sidebar_alloffers"
                            >
                                <img src="/assets/svg/priority_high.svg" alt="" />
                                <span className="material-icons-outlined">touch_app</span>
                                All Offers
                            </NavLink>
                        </ListItem> */}
                                <ListItem button>
                                    <ProtectedNavLink to="/saved_search" id="sidebar_my_alerts">
                                        <span className="material-icons">bookmark</span>
                                        {'Saved Search'}
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/watchlist/watchlist"
                                        id="sidebar_favourite"
                                    >
                                        <span className="material-icons">favorite</span>
                                        {'My Favourites'}
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/purchases/buynow"
                                        id="sidebar_mypurchases"
                                    >
                                        <span className="material-icons">shopping_basket</span>{' '}
                                        {'My Purchases'}
                                    </ProtectedNavLink>
                                </ListItem>{' '}
                                {/* <ListItem button>
                                    <ProtectedNavLink
                                        to="/purchases/overture"
                                        id="sidebar_mypurchases"
                                    >
                                        <span className="material-icons">shopping_basket</span>{' '}
                                        {'My Overtures'}
                                    </ProtectedNavLink>
                                </ListItem> */}
                                {/* <ListItem button>
                                    <NavLink activeClassName="active" to="/ioi_request">
                                        <span className="material-icons">storefront</span>{' '}
                                        {'Indication of Interest Request'}
                                    </NavLink>
                                </ListItem> */}
                                <ListItem
                                    button
                                    onClick={() => handleChange('payments')}
                                    id="sidebar_mypayments"
                                >
                                    <div
                                        className={`d-flex justify-content-between align-items-center w-100 test ${
                                            expanded === 'payments' && 'activeDropdown'
                                        }`}
                                    >
                                        <span className="d-flex navDrop">
                                            <span className="material-icons">credit_card</span>
                                            My Payments
                                        </span>
                                        {expanded === 'payments' ? <ExpandLess /> : <ExpandMore />}
                                    </div>
                                </ListItem>
                                <Collapse in={expanded === 'payments'} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        <ListItem button>
                                            <ProtectedNavLink to="/payments/transactions">
                                                Transactions
                                            </ProtectedNavLink>
                                        </ListItem>

                                        <ListItem button>
                                            <ProtectedNavLink
                                                to="/payments/saved_cards"
                                                id="sidebar_carddetails"
                                            >
                                                Card Details
                                            </ProtectedNavLink>
                                        </ListItem>
                                        <ListItem button>
                                            <ProtectedNavLink
                                                to="/payments/subscription"
                                                id="sidebar_mysubscrition"
                                            >
                                                My Subscription
                                            </ProtectedNavLink>
                                        </ListItem>
                                        <ListItem button>
                                            <ProtectedNavLink
                                                to="/payments/sub_transactions"
                                                id="sidebar_transactions"
                                            >
                                                My Subscription Transactions
                                            </ProtectedNavLink>
                                        </ListItem>
                                    </List>
                                </Collapse>
                            </>
                        ) : null}
                        {/* <ListItem button onClick={() => handleChange('seller/auctions')}>
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'seller/auctions' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex navDrop" id="sidebar_myauctions">
                                    <span className="material-icons">gavel</span>
                                    My Auctions
                                </span>
                                {expanded === 'seller/auctions' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem> */}

                        <Collapse in={expanded === 'seller/auctions'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/seller/auctions/open"
                                        id="sidebar_active"
                                    >
                                        Active
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/seller/auctions/closed"
                                        id="sidebar_sold"
                                    >
                                        Sold
                                    </ProtectedNavLink>
                                </ListItem>

                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/seller/auctions/draft"
                                        id="sidebar_draft"
                                    >
                                        Draft
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/seller/auctions/upcoming"
                                        id="sidebar_upcoming"
                                    >
                                        Upcoming
                                    </ProtectedNavLink>
                                </ListItem>
                            </List>
                        </Collapse>

                        <ListItem button onClick={() => handleChange('seller')} id="sidebar_mylots">
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'seller' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex navDrop">
                                    <span className="material-icons">gavel</span>
                                    My Offers
                                </span>
                                {expanded === 'seller' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>

                        <Collapse in={expanded === 'seller'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    {/* <li
                                        className="model"
                                        onClick={() => {
                                            if (user?.seniority == null) {
                                                setAlert(
                                                    'Please update your profile to post an offer',
                                                    'error',
                                                )

                                                handleRedirectInternal(history, 'account/profile')
                                            } else {
                                                toggleFullScreenPopup(true, 'new', 0)
                                            }
                                        }}
                                    > */}
                                    <ProtectedNavLink activeClassName="active" to="/add_offer">
                                        {/* <span className="material-icons-outlined">storefront</span> */}
                                        {'Add New Offer'}
                                        {/* </li> */}
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink to="/seller/lots/ioi/ioi_request">
                                        {/* <span className="material-icons-outlined">storefront</span> */}
                                        {'Indication of Interest Approval'}
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/seller/lots/upcomming"
                                        id="sidebar_active_lots"
                                    >
                                        Upcoming
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/seller/lots/open"
                                        id="sidebar_active_lots"
                                    >
                                        Active
                                    </ProtectedNavLink>
                                </ListItem>

                                <ListItem button>
                                    <ProtectedNavLink to="/seller/lots/sold" id="sidebar_sold_lots">
                                        Sold
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/seller/lots/unsold"
                                        id="sidebar_unsold_lots"
                                    >
                                        Unsold
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/seller/lots/draft"
                                        id="sidebar_draft_lots"
                                    >
                                        Draft
                                    </ProtectedNavLink>
                                </ListItem>
                                {/* <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/seller/lots/relisted"
                                        id="sidebar_relisted_lots"
                                    >
                                        Relisted
                                    </NavLink>
                                </ListItem> */}
                            </List>
                        </Collapse>

                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/sellers/product/templates">
                                <span className="material-icons">table_chart</span>
                                Listing Templates
                            </NavLink>
                        </ListItem> */}

                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/seller/templates">
                                <span className="material-icons-outlined">favorite</span>
                                Lot Templates
                            </NavLink>
                        </ListItem> */}

                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/seller/product/templates">
                                <span className="material-icons">table_chart</span>
                                Listing Templates
                            </NavLink>
                        </ListItem> */}

                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/seller/organization">
                                <span className="material-icons">corporate_fare</span>
                                Organization
                            </NavLink>
                        </ListItem> */}

                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/seller/reports">
                                <span className="material-icons">description</span>
                                Reports
                            </NavLink>
                        </ListItem> */}

                        {user.both_access == 1 && (
                            <ListItem button onClick={() => handleChange('invoices')}>
                                <div
                                    className={`d-flex justify-content-between align-items-center w-100 test ${
                                        expanded === 'invoices' && 'activeDropdown'
                                    }`}
                                >
                                    <span className="d-flex navDrop">
                                        <span className="material-icons">receipt</span>
                                        {'My Invoices'}
                                    </span>
                                    {expanded === 'invoices' ? <ExpandLess /> : <ExpandMore />}
                                </div>
                            </ListItem>
                        )}

                        <Collapse in={expanded === 'invoices'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <ProtectedNavLink to="/invoices/all">All</ProtectedNavLink>
                                </ListItem>

                                <ListItem button>
                                    <ProtectedNavLink to="/invoices/paid">Paid</ProtectedNavLink>
                                </ListItem>

                                <ListItem button>
                                    <ProtectedNavLink to="/invoices/partial">
                                        Unpaid
                                    </ProtectedNavLink>
                                </ListItem>
                            </List>
                        </Collapse>

                        {/* <ListItem
                            button
                            onClick={() => handleChange('payments')}
                            id="sidebar_mypayments"
                        >
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'payments' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex navDrop">
                                    <span className="material-icons">credit_card</span>
                                    My Payments
                                </span>
                                {expanded === 'payments' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>

                        <Collapse in={expanded === 'payments'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <NavLink activeClassName="active" to="/payments/transactions">
                                        Transactions
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/payments/saved_cards"
                                        id="sidebar_carddetails"
                                    >
                                        Card Details
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/payments/bank_details"
                                        id="sidebar_bankdetails"
                                    >
                                        Bank Details
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/payments/subscription"
                                        id="sidebar_mysubscrition"
                                    >
                                        My Subscription
                                    </NavLink>
                                </ListItem>
                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/payments/sub_transactions"
                                        id="sidebar_transactions"
                                    >
                                        My Subscription Transactions
                                    </NavLink>
                                </ListItem>
                            </List>
                        </Collapse> */}

                        {/* <ListItem button onClick={() => handleChange('payments')}>
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'payments' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex">
                                    <span className="material-icons">credit_card</span>
                                    My Payments
                                </span>
                                {expanded === 'payments' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>

                        <Collapse in={expanded === 'payments'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <NavLink activeClassName="active" to="/payments/transactions">
                                        Transactions
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/seller/payments/saved_cards"
                                    >
                                        Card Details
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/seller/payments/bank_details"
                                    >
                                        Bank Details
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/subscription">
                                        My Subscription
                                    </NavLink>
                                </ListItem>
                            </List>
                        </Collapse> */}
                    </>
                ) : (
                    <>
                        <ListItem
                            button
                            onClick={() => handleChange('auctions')}
                            id="sidebar_mybids"
                        >
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'auctions' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex navDrop">
                                    <span className="material-icons">gavel</span>
                                    {'My Bids'}
                                </span>
                                {expanded === 'auctions' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>
                        <Collapse in={expanded === 'auctions'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <ProtectedNavLink to="/auctions/ioi/ioi_request">
                                        {/* <span className="material-icons">storefront</span>{' '} */}
                                        {'Indication of Interest Request'}
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink to="/auctions/all" id="sidebar_all_bids">
                                        {'All'}
                                    </ProtectedNavLink>
                                </ListItem>

                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/auctions/winning"
                                        id="sidebar_winning_bids"
                                    >
                                        {'Winning'}
                                    </ProtectedNavLink>
                                </ListItem>

                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/auctions/outbid"
                                        id="sidebar_outbid_bids"
                                    >
                                        {'Currently Outbid'}
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink to="/auctions/won" id="sidebar_won_bids">
                                        {'Won'}
                                    </ProtectedNavLink>
                                </ListItem>
                            </List>
                        </Collapse>
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/ioi_request">
                                <span className="material-icons">storefront</span>{' '}
                                {'Indication of Interest Request'}
                            </NavLink>
                        </ListItem> */}
                        {/* <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/alloffers"
                                id="sidebar_alloffers"
                            >
                                <img src="/assets/svg/priority_high.svg" alt="" />
                                <span className="material-icons-outlined">touch_app</span>
                                All Offers
                            </NavLink>
                        </ListItem> */}
                        <ListItem button>
                            <ProtectedNavLink to="/saved_search" id="sidebar_my_alerts">
                                <span className="material-icons">bookmark</span>
                                {'Saved Search'}
                            </ProtectedNavLink>
                        </ListItem>
                        <ListItem button>
                            <ProtectedNavLink to="/watchlist/watchlist" id="sidebar_favourite">
                                <span className="material-icons">favorite</span>
                                {'My Favourites'}
                            </ProtectedNavLink>
                        </ListItem>
                        <ListItem button>
                            <ProtectedNavLink to="/purchases/buynow" id="sidebar_mypurchases">
                                <span className="material-icons">shopping_basket</span>{' '}
                                {'My Purchases'}
                            </ProtectedNavLink>
                        </ListItem>
                        {/* <ListItem button>
                            <ProtectedNavLink to="/purchases/overture" id="sidebar_mypurchases">
                                <span className="material-icons">shopping_basket</span>{' '}
                                {'My Overtures'}
                            </ProtectedNavLink>
                        </ListItem>{' '} */}
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/wallet" id="sidebar_mywallet">
                                <span className="material-icons">account_balance_wallet</span>
                                My Wallet
                            </NavLink>
                        </ListItem> */}
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/messages" id="sidebar_mywallet">
                                <span className="material-icons">message</span>
                                Message
                            </NavLink>
                        </ListItem> */}
                        {/* <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/transactions"
                                id="sidebar_transactions"
                            >
                                <span className="material-icons">swap_horizontal_circle</span>
                                My Transactions
                                </NavLink>
                            </ListItem> */}
                        <ListItem
                            button
                            onClick={() => handleChange('invoices')}
                            id="sidebar_myinvoices"
                        >
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'invoices' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex navDrop">
                                    <span className="material-icons">receipt</span>
                                    My Invoices
                                </span>
                                {expanded === 'invoices' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>
                        <Collapse in={expanded === 'invoices'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <ProtectedNavLink to="/invoices/all" id="sidebar_allinvoices">
                                        All
                                    </ProtectedNavLink>
                                </ListItem>

                                {/* <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/invoices/paid"
                                        id="sidebar_paid"
                                    >
                                        Paid
                                    </NavLink>
                                </ListItem> */}

                                <ListItem button>
                                    <ProtectedNavLink to="/invoices/partial" id="sidebar_unpaid">
                                        Unpaid
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink to="/invoices/paid" id="sidebar_paid">
                                        Paid
                                    </ProtectedNavLink>
                                </ListItem>
                            </List>
                        </Collapse>
                        <ListItem
                            button
                            onClick={() => handleChange('payments')}
                            id="sidebar_mypayments"
                        >
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'payments' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex navDrop">
                                    <span className="material-icons">credit_card</span>
                                    My Payments
                                </span>
                                {expanded === 'payments' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>
                        <Collapse in={expanded === 'payments'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <ProtectedNavLink to="/payments/transactions">
                                        Transactions
                                    </ProtectedNavLink>
                                </ListItem>

                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/payments/saved_cards"
                                        id="sidebar_carddetails"
                                    >
                                        Card Details
                                    </ProtectedNavLink>
                                </ListItem>

                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/payments/subscription"
                                        id="sidebar_mysubscrition"
                                    >
                                        My Subscription
                                    </ProtectedNavLink>
                                </ListItem>
                                <ListItem button>
                                    <ProtectedNavLink
                                        to="/payments/sub_transactions"
                                        id="sidebar_transactions"
                                    >
                                        My Subscription Transactions
                                    </ProtectedNavLink>
                                </ListItem>
                            </List>
                        </Collapse>
                        {/* <ListItem button>
                            <NavLink
                                activeClassName="active"
                                to="/saved_search"
                                id="sidear_savedsearches"
                            >
                                <span className="material-icons">bookmark</span> My Saved Searches
                            </NavLink>
                        </ListItem> */}
                    </>
                )}
            </ul>
            <DynamicListing data={manage} function={toggleFullScreenPopup} title={title} />
        </div>
    )
}

export default SideNav
